import React, { useState } from "react";
import axios from "axios";

const RequestPasswordResetPage: React.FC = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const backendUrl =
    process.env.REACT_APP_BACKEND_URL || "http://localhost:3001";

  const handleRequestReset = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    try {
      await axios.post(`${backendUrl}/api/requestpasswordreset`, {
        email,
      });
      setMessage(
        "If an account with that email exists, we have sent a link to reset your password."
      );
    } catch (error) {
      setError("We couldn’t send the reset link. Please try again.");
      console.error(error);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="mb-4">Reset your Reviewed password</h1>
        {error && <div className="alert alert-danger">{error}</div>}
        {message && <div className="alert alert-success">{message}</div>}
        <form onSubmit={handleRequestReset}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email:
            </label>
            <input
              type="email"
              className="form-control"
              id="email"
              value={email}
              onChange={event => setEmail(event.target.value)}
            />
          </div>
          <button type="submit" className="btn btn-primary mb-3">
            Send reset link
          </button>
        </form>
      </div>
    </div>
  );
};

export default RequestPasswordResetPage;
